<app-header></app-header>
<app-sidebar></app-sidebar>

<div class="content-wrapper" style="min-height: 307px">

  <!-- Content Header (Page header) -->
  <!-- <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Projects</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a href="#">Home</a></li>
            <li class="breadcrumb-item active">Projects</li>
          </ol>
        </div>
      </div>
    </div>
  </section> -->

  <section class="content">

    <div id="echart-001" style="align-items: center; width: 100%; height:400px;">
    </div>

    <!-- <div class="row" *ngIf="projectData.length > 0">
      <div class="col-12 col-sm-6 col-md-4 d-flex align-items-stretch flex-column">
        <div id="echart-001" style="align-items: center; width: 100%; height:400px;">
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 d-flex align-items-stretch flex-column">
        <div id="echart-002" style="align-items: center; width: 100%; height:400px;">
        </div>
      </div>
      <div class="col-12 col-sm-6 col-md-4 d-flex align-items-stretch flex-column">
        <div id="echart-003" style="align-items: center; width: 100%; height:400px;">
        </div>
      </div>
    </div> -->

    <!-- list โครงการแบบ contact -->
    <div class="card card-solid">
      <div class="card-body pb-0">
        <div class="row">
          <div *ngFor="let item of projectData; index as i"
            class="col-12 col-sm-6 col-md-4 d-flex align-items-stretch flex-column">
            <div class="card bg-light d-flex flex-fill">
              <div class="card-header text-muted border-bottom-0 ggSriracha">
                {{ item.supname }}
              </div>
              <div class="card-body pt-0">
                <div class="row" *ngIf="projectData.length >0">
                  <div class="col-7">
                    <h2 class="lead "><b class="ggPrompt">{{ item.projectName }}</b></h2>
                    <p class="text-muted text-sm ggSriracha"><b>จุดประสงค์: </b> {{ item.projectDescript }}</p>

                    <!-- <div *ngIf="item.projectCode == '001'" id="echart-001"
                      style="align-items: center; width: 100%; height:400px;">
                    </div>
                    <div *ngIf="item.projectCode == '002'" id="echart-002"
                      style="align-items: center; width: 100%; height:400px;">
                    </div>
                    <div *ngIf="item.projectCode == '003'" id="echart-003"
                      style="align-items: center; width: 100%; height:400px;">
                    </div> -->
                    <!-- <div id="chart-test01"></div> -->
                    <!-- <ul class="ml-4 mb-0 fa-ul text-muted">
                      <li class="small"><span class="fa-li"><i class="fas fa-lg fa-building"></i></span> Address:
                        Demo Street 123, Demo City 04312, NJ</li>
                      <li class="small"><span class="fa-li"><i class="fas fa-lg fa-phone"></i></span> Phone #: +
                        800 - 12 12 23 52</li>
                    </ul> -->
                  </div>
                  <div class="col-5 text-center">
                    <img [src]="item.suppic_url" alt="brd" class="img-circle img-fluid">
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="text-right">
                  <a href="#" class="btn btn-sm bg-teal">
                    <i class="fas fa-comments"></i>
                  </a>
                  <a (click)="moreProjectDetail(item.projectCode)" data-toggle="modal" data-target="#modal-brdproject"
                    class="btn btn-sm btn-primary">
                    <i class="fas fa-user"></i> View Project
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <nav aria-label="Contacts Page Navigation">
          <ul class="pagination justify-content-center m-0">
            <li class="page-item active"><a class="page-link" href="#">1</a></li>
            <li class="page-item"><a class="page-link" href="#">2</a></li>
            <li class="page-item"><a class="page-link" href="#">3</a></li>
            <li class="page-item"><a class="page-link" href="#">4</a></li>
            <li class="page-item"><a class="page-link" href="#">5</a></li>
            <li class="page-item"><a class="page-link" href="#">6</a></li>
            <li class="page-item"><a class="page-link" href="#">7</a></li>
            <li class="page-item"><a class="page-link" href="#">8</a></li>
          </ul>
        </nav>
      </div>
    </div>

    <!--  list โครงการแบบตาราง -->
    <div class="card">
      <div class="card-header">
        <h3 class="card-title">BRD Projects support</h3>

        <div class="card-tools">
          <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
            <i class="fas fa-minus"></i>
          </button>
          <button type="button" class="btn btn-tool" data-card-widget="maximize"><i class="fas fa-expand"></i>
          </button>
          <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </div>
      <div class="card-body p-0">
        <table class="table table-striped projects">
          <thead>
            <tr class="ggPrompt">
              <th style="width: 2%">
                #
              </th>
              <th style="width: 28%">
                Project Name
              </th>
              <th style="width: 10%">
                Team Members
              </th>
              <th style="width: 10%">
                ชาวไร่
              </th>
              <th style="width: 10%">
                แปลงอ้อย
              </th>
              <th style="width: 15%">
                <span class="w3-left">Project Progress</span> <span class="w3-right w3-text-teal">Succeed</span>
              </th>
              <th style="width: 15%" class="text-center">
                + ได้อ้อยเพิ่ม(ตัน)
              </th>
              <th style="width: 10%">
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of projectData; index as i ">
              <td>
                {{ i+1 }}
              </td>
              <td>
                <a>
                  {{ item.projectName }}
                </a>
                <br />
                <small>
                  {{ item.projectPeriodFrom | adtob }} - {{ item.projectPeriodEnd | adtob }}
                </small>
              </td>
              <td>
                <ul class="list-inline">
                  <li class="list-inline-item">
                    <img alt="brd" class="table-avatar" src="{{item.suppic_url}}">
                  </li>
                </ul>
              </td>
              <td>
                {{ item.projectFm | number: '1.0-0' }}
              </td>
              <td>
                {{ item.projectPlot | number: '1.0-0' }}
              </td>
              <td class="project_progress">
                <div class="progress progress-sm">
                  <div class="progress-bar bg-green" role="progressbar" aria-valuenow="{{ item.projectupdate }}"
                    aria-valuemin="0" aria-valuemax="100" [style.width]="item.projectupdate+'%'">
                  </div>
                </div>
                <small>
                  {{ item.projectupdate }}% Complete
                </small>
              </td>
              <td class="w3-center">
                <button class="w3-button w3-red w3-round-xxlarge">{{ item.getmorecane | number }}</button>
                <!-- <div class="w3-panel w3-border w3-round-xxlarge w3-red">
                  <p> <span class="ggPrompt txtLarger"> {{ item.getmorecane | number }}</span>.</p>
                </div> -->
              </td>
              <td class="project-actions text-right">
                <a class="btn btn-primary btn-sm" (click)="moreProjectDetail(item.projectCode)" data-toggle="modal"
                  data-target="#modal-brdproject">
                  <i class="fas fa-folder">
                  </i>
                  View
                </a>
                <!-- <a class="btn btn-info btn-sm" href="#">
                  <i class="fas fa-pencil-alt">
                  </i>
                  Edit
                </a>
                <a class="btn btn-danger btn-sm" href="#">
                  <i class="fas fa-trash">
                  </i>
                  Delete
                </a> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </section>

  <!-- Modal ข้อมูลเพิ่มเติมของโครงการ -->
  <div *ngIf="projectDetail" class="modal fade" id="modal-brdproject">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="ggPrompt txtXxlarge">
            <i class="fas fa-cog fa-spin"></i>
            โครงการ {{ projectDetail.projectName }} </h1>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <!-- Main content -->
          <section class="content">
            <div class="container-fluid">
              <div class="row">
                <div class="col-md-3">

                  <!-- Profile Image -->
                  <div class="card card-primary card-outline">
                    <div class="card-body box-profile">
                      <div class="text-center">
                        <img class="profile-user-img img-fluid img-circle" src="{{projectDetail.suppic_url}}"
                          alt="User profile picture">
                      </div>

                      <h3 class="profile-username text-center">{{ projectDetail.supname }}</h3>

                      <ul class="list-group list-group-unbordered mb-3">
                        <li class="list-group-item">
                          <b>แปลงเข้าโครงการ</b> <a class="float-right">1,322</a>
                        </li>
                        <li class="list-group-item">
                          <b>ชาวไร่เข้าโครงการ</b> <a class="float-right">543</a>
                        </li>
                        <li class="list-group-item">
                          <b>คาดได้อ้อยเพิ่ม</b> <a class="float-right">23,287</a>
                        </li>
                      </ul>

                      <a href="#" class="btn btn-primary btn-block"><b>Follow</b></a>
                    </div>
                    <!-- /.card-body -->
                  </div>
                  <!-- /.card -->

                  <div class="card card-primary">
                    <div class="card-header">
                      <h3 class="card-title">วัตถุประสงค์</h3>
                    </div>
                    <div class="card-body">
                      <div class="w3-panel w3-leftbar w3-light-grey">
                        <p class="ggSriracha">
                          <i>"{{ projectDetail.projectDescript }}"</i></p>
                        <!-- <p>Albert Einstein</p> -->
                      </div>
                    </div>
                  </div>
                </div>
                <!-- /.col -->
                <div class="col-md-9">
                  <div class="card">
                    <div class="card-header p-2">
                      <ul class="nav nav-pills">
                        <li class="nav-item"><a class="nav-link active" href="#activity" data-toggle="tab">ภาพรวม</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="#timeline" data-toggle="tab">รายละเอียด</a>
                        </li>
                        <li class="nav-item"><a class="nav-link" href="#settings" (click)="test02()"
                            data-toggle="tab">Settings</a>
                        </li>
                      </ul>
                    </div><!-- /.card-header -->
                    <div class="card-body">
                      <div class="tab-content">
                        <div class="active tab-pane" id="activity">
                          <div class="row justify-content-center" *ngIf="projectDetail.length>0">
                            <div id="chart-data-test" style="align-items: center; width: 600px;height:400px;"></div>
                          </div>
                        </div>
                        <!-- /.tab-pane -->
                        <div class="tab-pane" id="timeline">
                          <!-- The timeline -->
                          <div class="timeline timeline-inverse">
                            <!-- timeline time label -->
                            <div class="time-label">
                              <span class="bg-danger">
                                10 Feb. 2014
                              </span>
                            </div>
                            <!-- /.timeline-label -->
                            <!-- timeline item -->
                            <div>
                              <i class="fas fa-envelope bg-primary"></i>

                              <div class="timeline-item">
                                <span class="time"><i class="far fa-clock"></i> 12:05</span>

                                <h3 class="timeline-header"><a href="#">Support Team</a> sent you an email</h3>

                                <div class="timeline-body">
                                  Etsy doostang zoodles disqus groupon greplin oooj voxy zoodles,
                                  weebly ning heekya handango imeem plugg dopplr jibjab, movity
                                  jajah plickers sifteo edmodo ifttt zimbra. Babblely odeo kaboodle
                                  quora plaxo ideeli hulu weebly balihoo...
                                </div>
                                <div class="timeline-footer">
                                  <a href="#" class="btn btn-primary btn-sm">Read more</a>
                                  <a href="#" class="btn btn-danger btn-sm">Delete</a>
                                </div>
                              </div>
                            </div>
                            <!-- END timeline item -->
                            <!-- timeline item -->
                            <div>
                              <i class="fas fa-user bg-info"></i>

                              <div class="timeline-item">
                                <span class="time"><i class="far fa-clock"></i> 5 mins ago</span>

                                <h3 class="timeline-header border-0"><a href="#">Sarah Young</a> accepted your
                                  friend request
                                </h3>
                              </div>
                            </div>
                            <!-- END timeline item -->
                            <!-- timeline item -->
                            <div>
                              <i class="fas fa-comments bg-warning"></i>

                              <div class="timeline-item">
                                <span class="time"><i class="far fa-clock"></i> 27 mins ago</span>

                                <h3 class="timeline-header"><a href="#">Jay White</a> commented on your post</h3>

                                <div class="timeline-body">
                                  Take me to your leader!
                                  Switzerland is small and neutral!
                                  We are more like Germany, ambitious and misunderstood!
                                </div>
                                <div class="timeline-footer">
                                  <a href="#" class="btn btn-warning btn-flat btn-sm">View comment</a>
                                </div>
                              </div>
                            </div>
                            <!-- END timeline item -->
                            <!-- timeline time label -->
                            <div class="time-label">
                              <span class="bg-success">
                                3 Jan. 2014
                              </span>
                            </div>
                            <!-- /.timeline-label -->
                            <!-- timeline item -->
                            <div>
                              <i class="fas fa-camera bg-purple"></i>

                              <div class="timeline-item">
                                <span class="time"><i class="far fa-clock"></i> 2 days ago</span>

                                <h3 class="timeline-header"><a href="#">Mina Lee</a> uploaded new photos</h3>

                                <div class="timeline-body">
                                  <img src="https://placehold.it/150x100" alt="...">
                                  <img src="https://placehold.it/150x100" alt="...">
                                  <img src="https://placehold.it/150x100" alt="...">
                                  <img src="https://placehold.it/150x100" alt="...">
                                </div>
                              </div>
                            </div>
                            <!-- END timeline item -->
                            <div>
                              <i class="far fa-clock bg-gray"></i>
                            </div>
                          </div>
                        </div>
                        <!-- /.tab-pane -->

                        <div class="tab-pane" id="settings">

                          <!-- <div id="chart-test01" style="align-items: center; width: 500x; height:500px;">
                          </div> -->

                          <!-- <form class="form-horizontal">
                            <div class="form-group row">
                              <label for="inputName" class="col-sm-2 col-form-label">Name</label>
                              <div class="col-sm-10">
                                <input type="email" class="form-control" id="inputName" placeholder="Name">
                              </div>
                            </div>
                            <div class="form-group row">
                              <label for="inputEmail" class="col-sm-2 col-form-label">Email</label>
                              <div class="col-sm-10">
                                <input type="email" class="form-control" id="inputEmail" placeholder="Email">
                              </div>
                            </div>
                            <div class="form-group row">
                              <label for="inputName2" class="col-sm-2 col-form-label">Name</label>
                              <div class="col-sm-10">
                                <input type="text" class="form-control" id="inputName2" placeholder="Name">
                              </div>
                            </div>
                            <div class="form-group row">
                              <label for="inputExperience" class="col-sm-2 col-form-label">Experience</label>
                              <div class="col-sm-10">
                                <textarea class="form-control" id="inputExperience" placeholder="Experience"></textarea>
                              </div>
                            </div>
                            <div class="form-group row">
                              <label for="inputSkills" class="col-sm-2 col-form-label">Skills</label>
                              <div class="col-sm-10">
                                <input type="text" class="form-control" id="inputSkills" placeholder="Skills">
                              </div>
                            </div>
                            <div class="form-group row">
                              <div class="offset-sm-2 col-sm-10">
                                <div class="checkbox">
                                  <label>
                                    <input type="checkbox"> I agree to the <a href="#">terms and conditions</a>
                                  </label>
                                </div>
                              </div>
                            </div>
                            <div class="form-group row">
                              <div class="offset-sm-2 col-sm-10">
                                <button type="submit" class="btn btn-danger">Submit</button>
                              </div>
                            </div>
                          </form> -->
                        </div>
                        <!-- /.tab-pane -->
                      </div>
                      <!-- /.tab-content -->
                    </div><!-- /.card-body -->
                  </div>
                  <!-- /.card -->
                </div>
                <!-- /.col -->
              </div>
              <!-- /.row -->
            </div><!-- /.container-fluid -->
          </section>
          <!-- /.content -->
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default" data-dismiss="modal">Close</button>
          <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>

</div>

<app-footer></app-footer>
